const CHUNK_SIZE = 3800;

const AUTH_LARGE_COOKIES = ["access_token", "refresh_token", "permissions"];
const AUTH_COOKIES = [
  "admin_username",
  "admin_name",
  "admin_client",
  "admin_client_id",
  "azure_login_state",
];

export class CookieTool {
  static set(name, value, expiresDate) {
    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; SameSite=Strict`;
    if (expiresDate instanceof Date) {
      cookie += `; expires=${expiresDate.toUTCString()}`;
    }
    if (window.location.protocol === "https:") {
      cookie += "; Secure";
    }
    document.cookie = cookie;
  }

  static get(name) {
    const key = encodeURIComponent(name) + "=";
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      if (cookie.startsWith(key)) {
        return decodeURIComponent(cookie.slice(key.length));
      }
    }
    return null;
  }

  static remove(name) {
    document.cookie = `${encodeURIComponent(name)}=; path=/; max-age=0`;
  }

  static setLarge(baseName, value, expiresDate) {
    CookieTool.removeLarge(baseName);

    const chunks = [];
    for (let i = 0; i < value.length; i += CHUNK_SIZE) {
      chunks.push(value.slice(i, i + CHUNK_SIZE));
    }

    for (let i = 0; i < chunks.length; i++) {
      CookieTool.set(`${baseName}_chunk_${i}`, chunks[i], expiresDate);
    }
  }

  static getLarge(baseName) {
    const parts = [];
    let i = 0;
    let chunk;
    while ((chunk = CookieTool.get(`${baseName}_chunk_${i}`)) !== null) {
      parts.push(chunk);
      i++;
    }
    return parts.length > 0 ? parts.join("") : null;
  }

  static removeLarge(baseName) {
    let i = 0;
    while (CookieTool.get(`${baseName}_chunk_${i}`) !== null) {
      CookieTool.remove(`${baseName}_chunk_${i}`);
      i++;
    }
  }

  static clearAuth() {
    for (const name of AUTH_LARGE_COOKIES) {
      CookieTool.removeLarge(name);
    }
    for (const name of AUTH_COOKIES) {
      CookieTool.remove(name);
    }
  }

  static getTokenExpiry(token) {
    try {
      const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      const payload = JSON.parse(atob(base64));
      if (!payload.exp) return null;
      return new Date(payload.exp * 1000);
    } catch {
      return null;
    }
  }
}
